import RestrictionComponent from "../../../../../../JsonScreen/Screen/ScreenComponents/Restrictions/Restrictions";
const Restrictions = (props) => {
    const {component: {styles: sourceStyles} = {}} = props;
    const styles = sourceStyles ? sourceStyles[0] : {};

    return(
        <div style={{...styles}}>
            <RestrictionComponent
                designMode={true}
            />
        </div>

    )
}
export default Restrictions;